import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 10,
	viewBox: "0 0 11 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 5L6.625 8.5M10 5L6.625 1.5M10 5L1 5",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
